module.exports = __webpack_public_path__ + "static/media/mobile_stories_2x.a0d50e65.png";